var NavigationPerformanceSentry = /** @class */ (function () {
    function NavigationPerformanceSentry(entry) {
        this.entry = entry;
    }
    NavigationPerformanceSentry.prototype.generateSpan = function () {
        console.debug("going to generate span for navigation performance", this.entry);
    };
    return NavigationPerformanceSentry;
}());
export { NavigationPerformanceSentry };
//# sourceMappingURL=navigation.performance.sentry.js.map